import { SkeletonType } from '@/shared/types/layoutTypes';
import { Icon } from '@/shared/ui/Icon/Icon';
import clsx from 'clsx';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './Loading.module.scss';

export const MindSkeleton = (props: SkeletonType) => {
    const { items, isDark } = props;

    return (
        <div className={clsx(styles.root, isDark && styles.isDark)} style={{ margin: '0 auto', maxWidth: '1300px' }}>
            {Array.from({ length: items }, (_, index) => (
                <div className={styles.wrapper} key={index}>
                    <div>
                        <Skeleton className={styles.skeleton} width={276} height={276} />
                        <div className={styles.info}>
                            <Skeleton className={styles.skeleton} height={24} style={{ marginBottom: '4px' }} />
                            <Skeleton className={styles.skeleton} width={170} height={8} />
                        </div>
                    </div>
                    <div className={styles.icon}>
                        <Icon name="plus" />
                    </div>
                </div>
            ))}
        </div>
    );
};
